import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

// QualidadeItemProcessoRiscosListaColumns

type Props = {
  onActionEditar: ( Id: number | null, openState: boolean) => void,
  onActionDeletar: ( Id: number | null, openState: boolean) => void,
};

export const GenerateQualidadeItemProcessosRiscosColumns = ({
  onActionEditar,onActionDeletar,
}: Props): GridColDef[] => {

  return [
    {
      field: "Descricao", 
      filterable: false,
      headerName: "Processos", 
      flex: 1,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "NomeFuncionarioResponsavel",
      filterable: false,
      headerName: "Responsavel",
      flex: 1,
      minWidth: 150,
      sortable: false
    },
    {
      field: "DataAtualizacao",
      filterable: false,
      headerName: "Data Atualização",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
          return (<span>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
        }
    },
    {
    field: 'IdItemProcesso',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    width: 120,

    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center w-full h-full gap-1">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)} >
            <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
          </IconButton>

        </div>
      );
    }
    },
  ];
}